import React from 'react';
import { useQuery } from '@apollo/client/react';
import cn from 'clsx';
import styles from './styles.module.scss';
import { Panel } from '@pages-clean/central-monitoring/data-view/panels/panel';
import { IDataset } from '@pages-clean/central-monitoring/data-view/types';
import { useLocalState } from '@hooks/index';
import { GET_CM2_PANELS_DATAVIEW } from '@queries/central-monitoring';
import { getCm2PanelsDataview } from '@queries/generated/central-monitoring.generated';

type Props = {
    studyRef: string;
    dataset: IDataset;
    configId: string;
    mainPanelId: string;
    panelIds: string[];
    nonFilterablePanels: string[];
};

export const PanelsSection = ({ studyRef, dataset, configId, mainPanelId, panelIds, nonFilterablePanels }: Props) => {
    const panelRefs = [mainPanelId].concat(panelIds);
    const { state } = useLocalState();

    const processPanelsDate = dataset.created.toISOString();

    const { data, loading } = useQuery<getCm2PanelsDataview>(GET_CM2_PANELS_DATAVIEW, {
        variables: {
            organisationId: state?.selectedOrganisation?.id || state?.selectedStudy?.organisation?.id,
            studyId: studyRef,
            timestamp: processPanelsDate,
        },
        fetchPolicy: 'no-cache',
    });

    return (
        <div className={cn(styles.panelsSection, 'k-d-grid k-gap-2')}>
            {panelRefs.map((ref) => {
                const panelConfig = data?.cm2panels?.find((p) => p.id === ref);

                const nonFilterable = nonFilterablePanels.includes(ref);

                return (
                    <Panel
                        key={ref}
                        studyRef={studyRef}
                        datasetId={dataset.id}
                        panelRef={ref}
                        panelConfig={panelConfig}
                        loading={loading}
                        dataViewRef={configId}
                        showWaterMark={ref === mainPanelId}
                        screenFilterable
                        nonFilterable={nonFilterable}
                    />
                );
            })}
        </div>
    );
};
